import "./App.css";
import React, { useState } from "react";
import Amplify, { Auth } from "aws-amplify";
import { Navigate, Link } from "react-router-dom";

Amplify.configure({
  Auth: {
    region: "eu-central-1",
    userPoolId: process.env.REACT_APP_USERPOOL_ID,
    userPoolWebClientId: process.env.REACT_APP_APP_CLIENT_ID,
    mandatorySignIn: true,
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
});

function App(props) {
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [userFormFields, setUserFormFields] = useState({
    username: "",
    password: "",
  });
  const [loginError, setLoginError] = useState("");

  function handleChange(event) {
    setUserFormFields({
      ...userFormFields,
      [event.target.name]: event.target.value,
    });
  }

  async function handleLogIn(event) {
    event.preventDefault();
    try {
      await Auth.signIn(userFormFields.username, userFormFields.password);
      setUserLoggedIn(true);
    } catch (error) {
      console.log("error signing in", error);
      if (error.code === "UserNotFoundException") {
        setLoginError("User not found. Please check your credentials.");
      } else if (error.code === "NotAuthorizedException") {
        setLoginError("Incorrect username or password.");
      } else {
        setLoginError("An error occurred during sign-in.");
      }
    }
  }

  if (userLoggedIn) {
    return <Navigate to="/delete" replace={false} />;
  }

  return (
    <div className="container">
      <form>
        <h1>Login</h1>
        {loginError && <p className="error-message">{loginError}</p>}
        <div className="ui divider"></div>
        <div className="ui form">
          <div className="field">
            <label>Username</label>
            <input
              type="text"
              value={userFormFields.username}
              onChange={handleChange}
              name="username"
              placeholder="username"
            />
          </div>

          <div className="field">
            <label>Password</label>
            <input
              type="password"
              value={userFormFields.password}
              onChange={handleChange}
              name="password"
              placeholder="Password"
            />
          </div>
        </div>
        <div className="ui divider"></div>
        <div>
          <button onClick={handleLogIn} className="fluid ui button blue">
            Sign In
          </button>
        </div>
        <div className="ui divider"></div>
        <div>
          <Link to="/support" className="fluid ui button blue">
            Go to Support Page
          </Link>
        </div>
      </form>
    </div>
  );
}

export default App;
